import { createContext } from "react";

const consumoContext = createContext();

export default consumoContext;